var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Importar"}},[_c('Import')],1),_c('b-tab',{attrs:{"title":"Pesquisar NSU"}},[_c('ViewNSU')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }